export enum Roles {
  ApplicationAdmin = "ApplicationAdmin",
  ApplicationUser = "ApplicationUser",
  SelfUser = "SelfUser",
}
